import axios from 'axios'
import 'url-search-params-polyfill'
import moment from 'moment'
import _ from 'lodash'

import apiConfiguration from '../utilities/api/apiConfiguration'
import {getEndpointByHotelCode} from "../utilities/property/getClientIdByHotelCode";

import { setPropertyPolicies } from './fetchAvailability'
import triggerCustomGaEvent from "../utilities/analytics/triggerCustomGaEvent";
import getCookie from '../utilities/session/getCookie'

export const FETCH_ROOM_RATE_DETAILS_BEGIN   = 'FETCH_ROOM_RATE_DETAILS_BEGIN'
export const FETCH_ROOM_RATE_DETAILS_SUCCESS = 'FETCH_ROOM_RATE_DETAILS_SUCCESS'
export const FETCH_ROOM_RATE_DETAILS_FAILURE = 'FETCH_ROOM_RATE_DETAILS_FAILURE'

export const fetchRoomRateDetailsBegin = () => ({
	type: FETCH_ROOM_RATE_DETAILS_BEGIN,
})

export const fetchRoomRateDetailsSuccess = roomRateDetails => ({
	type: FETCH_ROOM_RATE_DETAILS_SUCCESS,
	payload: roomRateDetails
})

export const fetchRoomRateDetailsError = error => ({
	type: FETCH_ROOM_RATE_DETAILS_FAILURE,
	payload: { error }
})

// Handle Availability Fetch & Functionality
export default function fetchRoomRateDetails(roomGroup, roomTypeCode, ratePlanCode) {
	return (dispatch, getState) => {
		const urlData = getState().availabilityData.urlData
		let flowGuestData = null
		let sessionId = null

		if (
			getCookie('flowSessionId') &&
			getCookie('flowSessionId') !== ''
		) {
			sessionId = getCookie('flowSessionId')
		}

		if (localStorage.flowGuestData) {
			flowGuestData = JSON.parse(localStorage.flowGuestData)
		}

    let currentClientId = urlData.clientId || "ennismore";
		let currentEndpointUrl = getEndpointByHotelCode(urlData.hotelCode);

		let adultsVal = 1,
				childrenVal = 0,
				currentLanguage = 'en',
				currentCurrency = 'USD',
				startDateVal = moment(new Date()).format('YYYY-MM-DD'),
				endDateVal = moment(new Date()).add(1, 'days').format('YYYY-MM-DD'),
				hotelProvider = 0

		if (urlData.primaryLangId) {
			currentLanguage = urlData.primaryLangId
		}

		if (urlData.currency) {
			currentCurrency = urlData.currency
		}

		if (
			urlData.startDate &&
			urlData.startDate.includes('TODAY')
		) {
			startDateVal = moment().format('YYYY-MM-DD')
		} else if (urlData.startDate) {
			startDateVal = moment(urlData.startDate).format('YYYY-MM-DD')
		}

		if (
			urlData.endDate &&
			urlData.endDate.includes('TODAY')
		) {
			endDateVal = moment().add(urlData.endDate.replace('TODAY', ''), 'days').format('YYYY-MM-DD')
		} else if (urlData.endDate) {
			endDateVal = moment(urlData.endDate).format('YYYY-MM-DD')
		}

		// Set by session OR query with fallback
		if (!_.isEmpty(flowGuestData) && flowGuestData[roomGroup].adults) {
			adultsVal = Number(flowGuestData[roomGroup].adults)
		} else if (urlData.adults) {
			adultsVal = Number(urlData.adults)
		}

		// Set by session OR query with fallback
		if (!_.isEmpty(flowGuestData) && flowGuestData[roomGroup].children) {
			childrenVal = Number(flowGuestData[roomGroup].children)
		} else if (urlData.children) {
			childrenVal = Number(urlData.children)
		}

		if (urlData && urlData.hotelProvider) {
			hotelProvider = urlData.hotelProvider
		}

		// URL Params
		let urlParams = {
			resId: urlData.resId,
			startDate: startDateVal,
			endDate: endDateVal,
			adults: adultsVal,
			children: childrenVal,
			childAges: urlData.childAges,
			hotelCode: urlData.hotelCode,
			roomTypeCode: roomTypeCode,
			areaId: urlData.areaId,
			lat: urlData.lat,
			long: urlData.long,
			distance: urlData.distance,
			distanceMeasure: urlData.distanceMeasure,
			chainCode: urlData.chainCode,
			ratePlanCode: ratePlanCode,
			promoCode: urlData.promoCode,
			pricingMethod: urlData.pricingMethod,
			primaryLangId: currentLanguage,
			currency: currentCurrency,
			exactMatchOnly: urlData.exactMatchOnly,
			bestOnly: urlData.bestOnly,
			summaryOnly: urlData.summaryOnly,
			hotelStayOnly: urlData.hotelStayOnly,
			availReqType: urlData.availReqType,
			hotelProvider: hotelProvider,
			clientId: currentClientId,
			sessionId: sessionId,
		}

		// Fetch Query string method
		const fetchQuery = new URLSearchParams()

		// Loop urlParams for undefined values & remove
		for (let key in urlParams) {
			if (typeof urlParams[key] === "undefined") continue
			fetchQuery.append(key, urlParams[key])
		}

		// Base API path
		let apiBase = currentEndpointUrl + '/api/hotel/avail-rooms?'

		// Combine API URL & formatted urlParams
		const fetchResult = apiBase + fetchQuery.toString()

		dispatch(fetchRoomRateDetailsBegin())
		return axios.get(fetchResult, apiConfiguration())
			.then((response) => {
				let keyedRateDetails = {}

				// key response by specific room type, rate and group to support multi-room bookings (IE: distinguish rate differences)
				keyedRateDetails[roomTypeCode + '-' + ratePlanCode + '-' + roomGroup] = response.data['hydra:member'][0].roomStays[0].roomTypes[0].viewExtensions.roomRates[0]

				// Store hotel policies to be displayed secondary room/rate details requests (TARS)
				if (
					_.get(response.data['hydra:member'], '[0].roomStays[0].basicPropertyInfo.viewExtensions.policies') &&
					!_.isEmpty(response.data['hydra:member'][0].roomStays[0].basicPropertyInfo.viewExtensions.policies)
				) {
					dispatch(setPropertyPolicies(response.data['hydra:member'][0].roomStays[0].basicPropertyInfo.viewExtensions.policies))
				}

				// Dispatch adaDescription GA events
				const fetchRateDetailsData = {
					details: keyedRateDetails,
					status: 'success'
				}

				triggerCustomGaEvent('analytics-fetchAdditionalRoomRateDetails', fetchRateDetailsData)

				dispatch(fetchRoomRateDetailsSuccess(keyedRateDetails))
			})
			.catch(error => {
				// Dispatch adaDescription GA events
				const fetchRateDetailsData = {
					details: null,
					status: 'error'
				}

				triggerCustomGaEvent('analytics-fetchAdditionalRoomRateDetails', fetchRateDetailsData)
				dispatch(fetchRoomRateDetailsError(error))
			})
	}
}


// WEBPACK FOOTER //
// ./src/actions/fetchRoomRateDetails.js